import React from "react";
import "./KarenOrb.css";

/** Karen's shared identity; decorative when paired with a labelled control. */
export function KarenOrb({ active = false }) {
  return <span aria-hidden="true" className={`karen-orb ${active ? "karen-orb--active" : ""}`} />;
}

export default function KarenOrbButton({ active = false, large = false, label, ...props }) {
  return (
    <button
      {...props}
      type="button"
      className={`karen-orb-button ${large ? "karen-orb-button--large" : ""}`}
      aria-label={label || (active ? "Stop listening" : "Speak to Karen")}
      aria-pressed={active}
      title={label || (active ? "Stop listening" : "Speak to Karen")}
    >
      <KarenOrb active={active} />
    </button>
  );
}
